// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".merchant-app-list[data-v-0a250a98] {\n  margin: 20px;\n  background: #fff;\n  border-radius: 4px;\n}\n.filter-container[data-v-0a250a98] {\n  padding: 24px;\n  text-align: right;\n}\n.add-btn[data-v-0a250a98] {\n  color: #fff;\n}\n.search-frame[data-v-0a250a98] {\n  width: 160px;\n  margin-left: 5px;\n}\n.search-btn[data-v-0a250a98] {\n  margin-left: 10px;\n}\n.edit-btn[data-v-0a250a98] {\n  margin: 10px 0;\n}", ""]);
// Exports
module.exports = exports;
